"use client";

import { IPagination } from "@/types/strapi";
import Link from "next/link";

export function Pagination({ page, pageCount }: IPagination) {
	if (pageCount <= 1) return null;
	const pages = Array.from({ length: pageCount }, (_, i) => i + 1);
	return (
		<div className="flex justify-center items-center gap-3 mb-20">
			{pages.map((p) => (
				<Link
					key={p}
					href={`?page=${p}`}
					className={`transition-all ${
						p === page
							? "btn !bg-primary pointer-events-none"
							: "hover:font-bold"
					}`}
				>
					{p}
				</Link>
			))}
		</div>
	);
}
